/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { lastCreatedAt } from "~services/utils/helpers";

const useFaturamento = ({ clienteId, filters }) => {
  const [faturamentos, setFaturamentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gruposMateriais, setGruposMateriais] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [lastCreatedAtDate, setLastCreatedAtDate] = useState("");

  useEffect(() => {
    const fetchFaturamentos = async () => {
      setLoading(true);
      const idCliente = parseInt(clienteId);
      let query = db.faturamentos.where("clienteId").equals(idCliente);

      const gruposMateriaisArray = new Set();
      const produtosArray = new Set();
      await query.each((item) => {
        gruposMateriaisArray.add(item.grupoMaterialId);
        produtosArray.add(item.produtoId);
      });
      setGruposMateriais(Array.from(gruposMateriaisArray));
      setProdutos(Array.from(produtosArray));

      if (filters.grupoMaterialId || filters.produtoId) {
        query = query.filter(
          (faturamento) =>
            (filters.grupoMaterialId ? faturamento.grupoMaterialId === filters.grupoMaterialId : true) &&
            (filters.produtoId ? faturamento.produtoId === filters.produtoId : true)
        );
      }
      const result = [];
      await query.each((item) => result.push(item));

      setLastCreatedAtDate(lastCreatedAt(result));

      setFaturamentos(result);
      setLoading(false);
    };

    fetchFaturamentos();
  }, [clienteId, filters.grupoMaterialId, filters.produtoId]);

  return {
    faturamentos,
    faturamentoLastCreatedAtDate: lastCreatedAtDate,
    gruposMateriais,
    produtos,
    loading,
  };
};

export default useFaturamento;
